import { useEffect, useState } from "react";

const QUERY = "(min-width: 768px)";

// Matches Tailwind's `md:` breakpoint. Reactive to viewport changes so the
// app layout re-lays out if the user rotates or resizes.
export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(QUERY).matches : true
  );
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return isDesktop;
}
